/**
 * Format number pattern pt-BR
 * @param value
 * @param maximumFractionDigits
 * @returns {string}
 */
function numberFormat(value: string | number | null | undefined, maximumFractionDigits = 2): string {
  if (typeof value === 'string' && value !== '') value = parseFloat(value);

  value = !value ? 0 : value;

  return value.toLocaleString('pt-BR', {
    maximumFractionDigits,
    minimumFractionDigits: maximumFractionDigits,
  });
}

/**
 * Format currency pattern pt-BR
 * @param value
 * @param maximumFractionDigits
 * @returns {string}
 */
function moneyFormat(value: string | number | null | undefined, maximumFractionDigits = 2): string {
  if (typeof value === 'string' && value !== '') value = parseFloat(value);

  value = !value ? 0 : value;

  return value.toLocaleString('pt-BR', {
    style: 'currency',
    currency: 'BRL',
    maximumFractionDigits,
    minimumFractionDigits: maximumFractionDigits,
  });
}

/**
 * Format percent number pattern pt-BR
 * @param value
 * @param maximumFractionDigits
 * @returns {string}
 */
function percentFormat(value: string | number | null, maximumFractionDigits = 2): string {
  if (typeof value === 'string') value = parseFloat(value);

  value = !value ? 0 : value;

  return (
    value.toLocaleString('pt-BR', {
      maximumFractionDigits,
      minimumFractionDigits: maximumFractionDigits,
    }) + '%'
  );
}

function parseMoney(value: string | number): number {
  if (typeof value === 'number') return value;

  if (!value) return 0;

  return parseFloat(value.replace(/\./g, '').replace(',', '.'));
}

function formatBRL(value: number): string {
  if (!value) return '0,00';
  return value
    .toFixed(2) // 2 casas decimais
    .replace('.', ',') // decimal como vírgula
    .replace(/\B(?=(\d{3})+(?!\d))/g, '.'); // milhares
}

export { moneyFormat, numberFormat, percentFormat, parseMoney, formatBRL };
